import React from 'react'
import styled from 'styled-components'

import PopupIcon from '@pc/components/Works/Panel/shared/icons/PopupIcon'

const ModalButtonPopupIconBase = styled(PopupIcon)`
  color: #457ab5;
  margin-left: 4px;
`

const ModalButtonPopupIcon = () => <ModalButtonPopupIconBase width={14} height={14} />

export default ModalButtonPopupIcon
